import type { GetOrganizationsParams, Organization } from '@shared/types/entities';

import { api } from './client';
import { type PaginatedResponse, buildQuery } from './types';

export type { GetOrganizationsParams, Organization };

export async function getOrganizationsApi(params?: GetOrganizationsParams): Promise<PaginatedResponse<Organization>> {
  return api.get(`/organizations${buildQuery(params as Record<string, unknown>)}`);
}

export async function getOrganizationApi(id: number): Promise<Organization> {
  return api.get(`/organizations/${id}`);
}

export async function sendOrgMessageApi(
  orgId: number,
  data: { fullName: string; message: string; hcaptchaToken: string },
): Promise<void> {
  return api.post(`/organizations/${orgId}/message`, data);
}
